import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Row,
  Table,
} from "reactstrap";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { goBack } from "connected-react-router";
import Can from "../../components/can";
import PinModal from "../../components/pin";
import {
  deleteDstExtraRule,
  fetchDstExtraRule,
} from "../../actions/dst-extra-rules";
import { MONTH_NAMES } from "../../constants/month-names";

class DstExtraRule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
    };
    this.handleDelete = this.handleDelete.bind(this);
    this.requestDelete = this.requestDelete.bind(this);
    this.failedDelete = this.failedDelete.bind(this);
  }

  componentWillMount() {
    const { getDstExtraRule } = this.props;
    getDstExtraRule();
  }

  requestDelete(e) {
    e.preventDefault();
    this.setState({
      submitted: true,
    });
  }

  failedDelete() {
    this.setState({
      submitted: false,
    });
  }

  handleDelete() {
    const { deleteDstExtraRuleAction, goToList } = this.props;
    deleteDstExtraRuleAction().then(() => goToList());
  }

  render() {
    const { submitted } = this.state;
    const { dstExtraRule } = this.props;
    if (!dstExtraRule || Object.keys(dstExtraRule).length === 0) {
      return null;
    }
    return (
      <div className="animated fadeIn">
        {submitted && (
          <PinModal
            successSubmit={this.handleDelete}
            failedSubmit={this.failedDelete}
          />
        )}
        <Row>
          <Col lg={6}>
            <Card>
              <CardHeader>
                <strong>
                  {"DST Extra Rule ID: "}
                  {dstExtraRule.id}
                </strong>
                <div className="card-header-actions">
                  <Can I="update" a="DstExtraRule">
                    <Button
                      href={`/#/dst-extra-rules/${dstExtraRule.id}/edit`}
                      color="link"
                      className="card-header-action btn-setting"
                    >
                      <i className="icon-note" />
                    </Button>
                  </Can>
                  <Can I="delete" a="DstExtraRule">
                    <Button
                      color="link"
                      className="card-header-action btn-setting"
                      onClick={(e) => this.requestDelete(e)}
                    >
                      <i className="icon-trash" />
                    </Button>
                  </Can>
                </div>
              </CardHeader>
              <CardBody>
                <Table responsive striped hover>
                  <tbody>
                    <tr key="id">
                      <td>ID:</td>
                      <td>
                        <strong>{dstExtraRule.id}</strong>
                      </td>
                    </tr>
                    <tr key="year">
                      <td>Year:</td>
                      <td>
                        <strong>{dstExtraRule.year}</strong>
                      </td>
                    </tr>
                    <tr key="start_month">
                      <td>DST Start Month:</td>
                      <td>
                        <strong>{MONTH_NAMES[dstExtraRule.start_month]}</strong>
                      </td>
                    </tr>
                    <tr key="start_day">
                      <td>DST Start Day:</td>
                      <td>
                        <strong>{dstExtraRule.start_day}</strong>
                      </td>
                    </tr>
                    <tr key="end_month">
                      <td>DST End Month:</td>
                      <td>
                        <strong>{MONTH_NAMES[dstExtraRule.end_month]}</strong>
                      </td>
                    </tr>
                    <tr key="end_day">
                      <td>DST End Day:</td>
                      <td>
                        <strong>{dstExtraRule.end_day}</strong>
                      </td>
                    </tr>
                    <tr key="country.name">
                      <td>Country:</td>
                      <td>
                        <strong>
                          {!!dstExtraRule.country &&
                            !!dstExtraRule.country.name &&
                            dstExtraRule.country.name}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
              <CardFooter>
                <Button
                  href={`/#/dst-extra-rules/${dstExtraRule.id}/edit`}
                  color="secondary"
                  size="sm"
                >
                  Edit
                </Button>{" "}
                <Button
                  color="danger"
                  onClick={(e) => this.requestDelete(e)}
                  size="sm"
                >
                  Delete
                </Button>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

DstExtraRule.propTypes = {
  deleteDstExtraRuleAction: PropTypes.func.isRequired,
  getDstExtraRule: PropTypes.func.isRequired,
  goToList: PropTypes.func.isRequired,
  dstExtraRule: PropTypes.shape({}),
};

DstExtraRule.defaultProps = {
  dstExtraRule: {},
};

const mapStateToProps = ({ dstExtraRules }) => ({
  dstExtraRule: dstExtraRules.item,
});

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      deleteDstExtraRuleAction: () =>
        deleteDstExtraRule(ownProps.match.params.id),
      getDstExtraRule: () => fetchDstExtraRule(ownProps.match.params.id),
      goToList: () => goBack(),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DstExtraRule);
